<template>
    <header class="NavigationBlock" :id=block_id>
        <div class="bg-white">
            
            <!-- Gradient Bar -->
            <div class="w-full h-2 bg-gradient-to-r from-primary-500 via-tertiary-500 to-secondary-500"></div>

            <div class="container-nav">
                <header class="flex items-center justify-between">
                    
                    <!-- Logo -->
                    <a href="/" class="flex-shrink-0">
                        <img class="h-8 md:h-12" src="@/assets/icons/logo-lw/light.svg" alt="Logo">
                    </a>

                    <!-- Desktop Nav -->
                    <div class="flex-col items-end hidden gap-4 lg:flex">
                        
                        <!-- Secondary Navigation -->
                        <nav class="flex items-center gap-8">

                            <cta-socials />
                            
                            <cta-phone />

                            <cta-email />

                        </nav>

                        <!-- Main Navigation -->
                        <nav class="flex items-baseline gap-10">
                            
                            <!-- Navigation -->
                            <a v-for="item in nav_items" :key="item.id" :title="item.description" :aria-label="item.description" :href="item.url" class="btn btn-md btn-link btn-neutral">
                                {{ item.title }}
                            </a>

                            <!-- Secondary CTA -->
                            <a class="btn btn-md btn-link btn-secondary" target="_blank" href="../../files/menu.pdf">View Menu</a>

                            <!-- Main CTA -->
                            <a class="btn btn-md btn-filled btn-primary" target="_blank" href="https://goodeats.io/LATINWAY">Order now</a>

                        </nav>
                        
                    </div>

                    <!-- Mobile -->
                    <div class="flex items-center justify-end lg:hidden">

                        <!-- Burger -->
                        <button aria-label="Open Mobile Nav" @click="showModal = true" class="transition cursor-pointer text-neutral-800 hover:text-neutral-700">
                            <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path>
                            </svg>
                        </button>

                        <!-- Nav -->
                        <nav-modal :show="showModal" :nav_items="nav_items" @close="showModal = false" />

                    </div>
                    
                </header>
            </div>
        </div>
    </header>
</template>

<script>

    import NavModal from '../components/MobileNav';
    import CtaPhone from '../components/cta/CtaPhone';
    import CtaEmail from '../components/cta/CtaEmail';
    import CtaSocials from '../components/cta/CtaSocials';

    export default {
        
        name: 'NavigationBlock',

        components: {
            NavModal,
            CtaPhone,
            CtaEmail,
            CtaSocials
        },

        data(){
            return {

                block_id: "Navigation",
                
                // Modal
                showModal: false,

                // Nav Items
                nav_items: [
                    { title: "Timetable", description: "Timetable", url: "#Timetable" },
                    { title: "How to Order", description: "How to Order", url: "#Order" },
                    { title: "About Us", description: "About Us", url: "#About" },
                    { title: "Contact Us", description: "Contact Us", url: "#Contact" },
                ]
            }
        }
    }
</script>